'use client';

import { Button, Flex, IconButton, Stack } from '@chakra-ui/react';
import { memo, useCallback, useState } from 'react';

import ExpandableSearchButton from '@components/common/ExpandableSearchButton';
import ContractCard from '@features/positions/hedgePositions/ContractCard';
import { allContracts } from 'helpers/fakeData';
import { useHref } from 'hooks/useHref';
import { useRouter } from 'next/navigation';
import { FilterIcon, PlusIcon } from 'vectors';

const HedgePositionsPage = () => {
  const router = useRouter();
  const { exploreHref } = useHref();
  const [searchQuery, setSearchQuery] = useState('');

  const onClickNewPosition = useCallback(() => {
    const href = exploreHref('demand');
    router.push(href);
  }, [exploreHref]);

  return (
    <Flex flexDirection="column" h="full" p={4}>
      <Flex borderBottomWidth="1px" borderColor="border.light" pb={3} alignItems="center">
        <Flex ml="auto" gap={2} alignItems="center">
          <ExpandableSearchButton
            query={searchQuery}
            setQuery={setSearchQuery}
            size="xs"
            iconColor="text.secondary"
          />
          <IconButton variant="ghost" size="xs" borderRadius="md">
            <FilterIcon color="text.secondary" />
          </IconButton>
          <Button size="2xs" borderRadius="md" onClick={onClickNewPosition}>
            New hedge <PlusIcon />
          </Button>
        </Flex>
      </Flex>
      <Stack gap={6} pt={4}>
        {allContracts.map((contract) => (
          <ContractCard key={contract.id} contract={contract} />
        ))}
      </Stack>
    </Flex>
  );
};

export default memo(HedgePositionsPage);
